<base-modal [title]="title" [isLoading]="isLoading" [btnOkClass]="'btn-success'" [btnOkLabel]="'Далее'" (onOk)="ok()">
	<p *ngIf="lastEditUser!=null">{{'adminstat.support.accessor.lastEdit' | translate}}: {{lastEditUser}} - {{lastEditTime}}</p>
	<br />
	<a target="_blank" rel="noreferrer" href="http://{{preview}}">Просмотреть сайт {{preview}}</a>
	<table class="table">
		<tr>
			<td width="40%">
				<label>{{'adminstat.support.accessor.Category' | translate}}</label>
				<select class="form-control js-accessors-categories" [(ngModel)]="category" (ngModelChange)="calcSubcategories()" size="30">
					<option *ngFor="let opt of categories | keys" value="{{opt}}">{{opt}}</option>
				</select>
			</td>

			<td width="40%">
				<label>{{'adminstat.support.accessor.Subject' | translate}}</label>
				<select class="form-control js-accessors-subjects" [(ngModel)]="subject" size="30">
					<option *ngFor="let opt of subcategories" value="{{opt}}">{{opt}}</option>
				</select>
			</td>

			<td width="20%">
				<label>{{'adminstat.support.accessor.defer' | translate}}</label>
				<select class="form-control js-accessors-defer" [(ngModel)]="defer">
					<option value=""></option>
					<option value="1">{{'adminstat.support.accessor.unfinished site' | translate}}</option>
					<option value="2">{{'adminstat.support.accessor.no right category' | translate}}</option>
				</select>
			</td>
		</tr>
	</table>
</base-modal>

